// extracted by mini-css-extract-plugin
export default {"error-message":"NFa_N3"};